import en from './en';
import hi from './hi';
import ch from './ch';
import es from './es';
import fr from './fr';
import ru from './ru';
import ar from './ar';
export default { en, hi, ch, es, fr, ru, ar };
